import { MonteCarloConstants } from "Widgets/Scripts/MonteCarloWidget/MonteCarloConstants";
import { MonteCarloSettings } from 'Widgets/Scripts/MonteCarloWidget/MonteCarloSettings';
import BurndownSettingsManager from 'Widgets/Scripts/Burndown/BurndownSettingsManager';
import { TeamContext } from 'VSS/Common/Contracts/Platform';

export default class MonteCarloSettingsManager extends BurndownSettingsManager {
    public getFeatureName(): string {
        return MonteCarloConstants.featureName;
    }

    protected packDefaultSettings(teamContext: TeamContext): MonteCarloSettings {
        let monteCarloSettings = <MonteCarloSettings>super.packDefaultSettings(teamContext);

        return {
            ...monteCarloSettings,
            isShowStatisticalProbabilitiesEnabled: true,
            isUseDurationsCheckboxEnabled: false
        };
    }
}